import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessionData } from 'src/utils/CommonFunctions';

// useLoginCheck custom hook to check the user login or not
const useLoginCheck = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const isLogin = getSessionData('Login_Sucess'); // using sessionStorage
    if (isLogin !== 'true') {
      navigate('/');
    }
  }, []); // This ensures the effect runs only once when the component mounts
};

export default useLoginCheck;
